import { style, styleVariants } from '@vanilla-extract/css'
import { vars } from '../design/theme.css'

// The shared activity sparkline — Live's living green line, and the species sheet's stilled,
// greyscale twin (`muted`). Migrated off editorial.css's .today-spark-* so both call sites carry
// their own tokens rather than leaning on a global cascade.
export const plot = style({ position: 'relative' })

export const svg = styleVariants({
  live: {
    display: 'block',
    width: '100%',
    height: '104px',
    '@media': { 'screen and (max-width: 560px)': { height: '64px' } },
  },
  muted: { display: 'block', width: '100%', height: '66px' },
})

export const line = styleVariants({
  live: { stroke: vars.color.green, strokeWidth: 1.75, vectorEffect: 'non-scaling-stroke' },
  muted: { stroke: vars.color.inkSoft, strokeWidth: 1.75, vectorEffect: 'non-scaling-stroke' },
})

// The soft gradient fill belongs to the living line only; the stilled twin drops it.
export const fillHidden = style({ display: 'none' })
